var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotATest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 40C1 17.9067 18.9106 0 41 0C63.0894 0 81 17.9106 81 40C81 62.0894 63.0894 80 41 80C18.9106 80 1 62.0894 1 40Z",
    fill: "#FFD100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9067 17.9106 0 40 0C62.0894 0 80 17.9106 80 40C80 62.0894 62.0894 80 40 80C17.9106 80 0 62.0894 0 40Z",
    fill: "#FFD100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8823 3.5784C42.8823 2.70718 43.5895 2 44.4607 2C45.332 2 46.0391 2.70718 46.0391 3.5784C46.0391 4.44962 45.332 5.15681 44.4607 5.15681C43.5895 5.15681 42.8823 4.44962 42.8823 3.5784Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 4.08525C36 3.21403 36.7072 2.50684 37.5784 2.50684C38.4496 2.50684 39.1568 3.21403 39.1568 4.08525C39.1568 4.95647 38.4496 5.66365 37.5784 5.66365C36.7072 5.66365 36 4.95647 36 4.08525Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4836 8.78401C40.1008 7.29309 40.4726 5.91154 41.3183 5.69282C42.164 5.4741 43.1592 6.50571 43.5419 7.99663C43.9247 9.48755 43.5529 10.8691 42.7072 11.0878C41.8615 11.3065 40.8663 10.2749 40.4836 8.78401Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1071 38C72.6072 38 77.3339 38 78.8574 38C80.3809 38 80.3809 42 78.8574 42C74.6385 42 74.6385 41.9997 70.1071 42C68.6617 42.0001 68.6005 38 70.1071 38Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10711 38C5.60718 38 10.3339 38 11.8574 38C13.3809 38 13.3809 42 11.8574 42C7.63849 42 7.63849 41.9997 3.10711 42C1.66174 42.0001 1.60051 38 3.10711 38Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77.8929C39 75.3928 39 70.6661 39 69.1426C39 67.6191 43 67.6191 43 69.1426C43 73.3615 42.9997 73.3615 43 77.8929C43.0001 79.3383 39 79.3995 39 77.8929Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7828 64.9955C14.5507 63.2277 17.893 59.8854 18.9702 58.8081C20.0475 57.7308 22.8759 60.5593 21.7987 61.6365C18.8154 64.6197 18.8152 64.6195 15.6113 67.8239C14.5893 68.846 11.7175 66.0608 12.7828 64.9955Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7828 17.9955C61.5507 16.2277 64.893 12.8854 65.9702 11.8081C67.0475 10.7308 69.8759 13.5593 68.7987 14.6365C65.8154 17.6197 65.8152 17.6195 62.6113 20.8239C61.5893 21.846 58.7175 19.0608 59.7828 17.9955Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6115 58.7828C64.3793 60.5507 67.7216 63.893 68.7988 64.9702C69.8761 66.0475 67.0477 68.8759 65.9704 67.7987C62.9872 64.8154 62.9874 64.8152 59.783 61.6113C58.7609 60.5893 61.5461 57.7175 62.6115 58.7828Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.151 39.7971C45.7415 42.4771 52.5298 47.544 54.7177 49.1771C56.9056 50.8102 54.513 54.0157 52.3251 52.3826C46.2661 47.8601 46.2663 47.8599 39.7584 43.0026C37.6825 41.4533 39.9873 38.1821 42.151 39.7971Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40.7954C39 34.6937 39 23.5068 39 19.7886C39 16.0705 43 16.0705 43 19.7886C43 30.0852 42.9997 30.0852 43 41.1444C43.0001 43.8922 41.5 42.8352 40 42.6259C39.5 42.6258 39 41.1444 39 40.7954Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6115 11.7828C17.3793 13.5507 20.7216 16.893 21.7988 17.9702C22.8761 19.0475 20.0477 21.8759 18.9704 20.7987C15.9872 17.8154 15.9874 17.8152 12.783 14.6113C11.7609 13.5893 14.5461 10.7175 15.6115 11.7828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotATest);
export default __webpack_public_path__ + "static/media/Not_a_test.ab87f9be0fe57e33fcd7f4473e862756.svg";
export { ForwardRef as ReactComponent };